export class Vas {
  public id: string;
  public categoryId: string;
  public categoryInitCharge: number;
  public name: string;
  public initCharge: number;
  public monthlyCharge: number;
  public maxValue: number;
  public link: string;

  constructor(
    id: string,
    data: any,
    categoryId: string,
    categoryName: string,
    categoryInitCharge: number
  ) {
    this.id = id;
    this.categoryId = categoryId;
    this.categoryInitCharge = categoryInitCharge;
    this.name = categoryName + ' ' + data.name;
    this.initCharge = data.init_charge;
    this.monthlyCharge = data.monthly_charge;
    this.maxValue = data.max_value;
    this.link = data.link;
  }
}
